import { Paragraph } from "@bokio/designsystem/components/TypographicElements/TypographicElements";
import { Link } from "@bokio/elements/Link/Link";
import { GeneralLangFactory } from "@bokio/lang";
import { formatMessage } from "@bokio/shared/utils/format";

import type { FC } from "react";

export const SensitiveInfoReminderLink: FC = () => {
	const generalLang = GeneralLangFactory();

	return (
		<Paragraph style={"caption-light"}>
			{formatMessage(generalLang.SensitiveInfoReminderMessage_Markdown, text => (
				<Link external="https://www.bokio.se/villkor-och-gdpr/integritetspolicy/" target="_blank">
					{text}
				</Link>
			))}
		</Paragraph>
	);
};
